module.exports = __webpack_public_path__ + "img/Logo-1-footer-612_82.dedbcd63.jpg";